module.exports = ".popup {\n  margin: 5% 15%;\n  border: 2px solid #000;\n  background: #fff;\n  position: absolute;\n  z-index: 999; }\n\ntable td {\n  font-size: 0.7rem;\n  padding: 2px; }\n\nthead.summary th {\n  border-top: none; }\n\ntbody.summary td {\n  border: none; }\n\nth, tbody.center td {\n  text-align: center; }\n\ntd.center {\n  text-align: center; }\n\ntd.glyphicon {\n  margin-left: 25%;\n  border: none; }\n\n.left {\n  float: left; }\n\n.right {\n  float: right; }\n\n.popupBtn {\n  background: #302626;\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/mybag/mybag.component.scss
// module id = ./src/app/content/mybag/mybag.component.scss
// module chunks = main